const Footer = () => {
  return (
    <div>
      {" "}
      <div className="Footer">
        <br />
        <span className="open-source">
          This project was coded by Natalie Gilliam, is open-sourced on{" "}
        </span>
        <a
          href="https://github.com/NatCorona89/Portfolio-Project"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>{" "}
        <span className="open-source">and hosted on </span>
        <a
          href="https://app.netlify.com/sites/friendly-wozniak-e483a6/overview"
          target="blank"
          rel="noopener noreferrer"
        >
          Netlify
        </a>
      </div>
    </div>
  );
};

export default Footer;
